import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ShareDataView } from '../../components/ShareDataView/ShareDataView';
import {
  IShareContactPopupParams,
  useShareContactPopupPresenter,
} from './ShareContactPopup.presenter';

export const ShareContactPopup: FC<ICommonPopupsProps<IShareContactPopupParams>> = observer(
  (props) => {
    const presenter = useShareContactPopupPresenter(props);
    const { t } = useTranslation();
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('share_contact')}
        isOpened
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <ShareDataView onChangeSelection={presenter.onSelect} />
      </Popup>
    );
  }
);
